import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom"; 
import {FournisseurAuth, useAuth} from "./context/AuthContext"; 
import Connexion from "./pages/Login";
import Tableau from "./pages/Dashboard";
import NouvelleReunion from "./pages/NewMeeting";
import Archives from "./pages/Archive";
import GestionTemplates from "./pages/Templates";
import Layout from "./components/Layout"; 
import Inscription from "./pages/Register";
import Spinner from "./components/Spinner";

function RouteProtegee({children}: {children: React.ReactNode}) {
  const {estConnecte, chargementAuth} = useAuth();
  if (chargementAuth) return (
    <div className="flex justify-center items-center h-screen">
      <Spinner size="lg" className="text-purple-600"/>
    </div>
  );
  return estConnecte ? <>{children}</> : <Navigate to="/connexion"/>;
}

function App() {
  return (
    <FournisseurAuth>
      <BrowserRouter>
        <Routes>
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/tableau" element={
            <RouteProtegee><Layout><Tableau /></Layout></RouteProtegee>
          } />
          <Route path="/nouvelle-reunion" element={
            <RouteProtegee><Layout><NouvelleReunion /></Layout></RouteProtegee>
          } />
          <Route path="/archives" element={
            <RouteProtegee><Layout><Archives /></Layout></RouteProtegee>
          } />
          <Route path="/templates" element={
            <RouteProtegee><Layout><GestionTemplates /></Layout></RouteProtegee>
          } />
          <Route path="*" element={<Navigate to="/connexion" />} />
        </Routes>
      </BrowserRouter>
    </FournisseurAuth>
  ); 
}

export default App;